import moment, { Moment } from 'moment';
import { DictionaryContextType } from '../dictionaries/context/DictionaryContextTypes';
import { BankType, BrandType, NegotiationOption, NegotiationOptionAlternative, NegotiationState, OutDebt, OutDebtFieldsFragment } from '../generated/graphql';
import thousandSeparator from './thousandSeparator';
import { addBusinessDays } from './addBusinessDays';

type ContentInstallmentsPlanBancoBogotaType = {
  gT: (key: string, context?: DictionaryContextType) => string,
  outDebt: OutDebt,
  negOption?: NegotiationOption,
  outDebts?: Array<OutDebtFieldsFragment>,
  alternative?: NegotiationOptionAlternative,
  isConsequences?: boolean,
};

enum BancoBogotaInstallmentsPlanKeys {
  General = 'alert_paymentAlert_content_InstallmentsPlan',
  SentToBank = 'negotiation_InstallmentsPlanVIRTUAL_confirmation_description_SENT_TO_BANK',
  ApprovedByBank = 'negotiation_InstallmentsPlanVIRTUAL_confirmation_description_APPROVED_BY_BANK',
  Consequences = 'negotiation_InstallmentsPlan_consequences',
}

const { Consequences, SentToBank, ApprovedByBank } = BancoBogotaInstallmentsPlanKeys;
export const getContentInstallmentsPlanBancoBogota = (
  props : ContentInstallmentsPlanBancoBogotaType,
) => {
  const { gT, outDebts, outDebt, negOption: option, alternative } = props;

  if (!option || !alternative) return null;

  const outDebtHeadProductNumber = outDebts?.find(({ bank, brand, extra }) => (
    bank === BankType.BancoDeBogota && brand === BrandType.Tranquiapp && extra?.headProductNumber
  ))?.productNumber || '';

  const businessDaysAdded = 5;

  const formatDate = (inputDate?: Date | string | Moment, format = 'LL') => {
    const date = moment(inputDate);
    return date.isValid() ? date.format(format) : '';
  };

  const childrenDebts = outDebt.extra?.children?.map((ch) => (ch.productNumber)).join(', ')
    || outDebt.productNumber || '';

  const context = {
    monthlyPayment: thousandSeparator(alternative.value),
    negPaymentDate: moment(option.settings?.maxPaymentDate).format('LL'),
    productNumber: outDebt.productNumber || '',
    bank: outDebt.bank,
    headProductNumber: outDebtHeadProductNumber || '',
    childrenDebts,
    certificationDate: formatDate(addBusinessDays(
      moment(outDebt.negotiation?.updatedAt), businessDaysAdded,
    )),
  };

  const texts = [];

  const state = outDebt.negotiation?.state;

  const approved = state === NegotiationState.ApprovedByBank;

  if (state === NegotiationState.SentToBank) texts.push(gT(SentToBank, context));
  if (approved) texts.push(gT(ApprovedByBank, context));

  if (!approved) texts.push(gT(Consequences, context));

  return texts.join('\n');
};
